import React, { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'
import logo from 'images/mymorri_logo.svg'

const ErrorPage = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: pathname, title: "Error" })
  }, [])

  return (
    <div
      id="error_page"
      className="flex flex-col items-center justify-center h-screen bg-green"
    >
      <div className="relative flex flex-col items-center justify-center p-4">
        <div className="h-32 mb-8">
          <img
            alt="Morrisons MyMorri"
            className="block w-auto h-full mx-auto"
            src={logo}
          />
        </div>
        <div className="mt-4 text-lg text-center text-orange">
          Oops! We're sorry, it looks like something has gone wrong.
          <div className='mt-4'>Please close this window and try again in a new window.</div>
        </div>
        <div className="mt-4 text-lg text-center text-white">
          <p className="pb-4">
            For further assistance with MyMorri, feel free to call the MyMorri Helpline at{' '}
            <span className="whitespace-no-wrap">0330 041 5587</span>
          </p>
          <p>The Helpline is open 24 hours a day, 365 days a year.</p>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
